import { createContext, useContext, type ReactNode } from "react";
import type { AuthenticationSession } from "./AuthenticationSession";

export type AuthenticationActions = Readonly<{
  logout(): Promise<void>;
}>;

type AuthContextValue = AuthenticationActions;

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({
  session,
  children,
}: {
  readonly session: AuthenticationSession;
  readonly children: ReactNode;
}) {
  return (
    <AuthContext.Provider value={{ logout: () => session.logout() }}>
      {children}
    </AuthContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useAuthenticationActions(): AuthenticationActions {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthenticationActions must be used within AuthProvider");
  }
  return context;
}